import { render, staticRenderFns } from "./Travel.vue?vue&type=template&id=368591ae&scoped=true&"
import script from "./Travel.vue?vue&type=script&lang=js&"
export * from "./Travel.vue?vue&type=script&lang=js&"
import style0 from "./Travel.vue?vue&type=style&index=0&id=368591ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368591ae",
  null
  
)

export default component.exports